import AsoHeader from "../../../components/Aso/Header";
import InformacoesDocumento from "../../../components/Reaproveitamentos/InformacoesDocumento";

export const InformacoesDocumentos = () => {
  return(
    <>
      <AsoHeader />
      <InformacoesDocumento />
    </>
  );
}